import settings from "../settings";
import http from "../http";
import serviceClient from "../serviceClient";
import featureFlags from "../featureFlags";
import dates from "../dates";
import * as inactivityLogout from "./inactivityLogout";
import user from "../user";
import { getDeviceGuid } from "../deviceGuid";
let authSettings = {};
let authLog = "";

async function getTenantFromHost(typedTenant) {
  try {
    let hostname;

    //example of checking a feature flag
    console.log('feature flag check', await featureFlags.checkFeatureFlag('example-for-tests'))

    if (!typedTenant) {

      hostname = location.hostname;
      hostname = hostname.toLowerCase();
    }

    if (typedTenant) {
      typedTenant = typedTenant.toLowerCase();
    }

    // TODO: deal with the data_instances not having integrifydev.localhost entry
    // if (hostname === 'integrifydev.localhost') {
    //   hostname = 'integrify.demo';
    // }

    const tenantClient = await serviceClient.getClient('tenant');
    let result;
    try {
      result = await tenantClient.apis.tenant.getTenantLoginSettings({hostHeader: hostname, tenant: typedTenant})      
    } catch (error) {
      console.error('error getting tenant login settings', error);
      result = null;
    }
    const tenant = result ? JSON.parse(result.data) : null;

    if (tenant && tenant.ID) {
      localStorage.setItem('defaultTheme', tenant.Theme || 'mono-blue');
      localStorage.setItem('LogoUrl', tenant.LogoUrl || '');
      sessionStorage.setItem('tenant', tenant.ID);
      localStorage.setItem('tenant', tenant.ID);
      if (tenant.CustomTheme) localStorage.setItem('CustomTheme', tenant.CustomTheme);

      // GlobalDateFormat, GlobalDateOnlyFormat, GlobalTimeOnlyFormat
      if (tenant.GlobalDateFormat) localStorage.setItem('GlobalDateFormat', dates.convertDateFormat(tenant.GlobalDateFormat))
      else localStorage.removeItem('GlobalDateFormat');
      if (tenant.GlobalDateOnlyFormat) localStorage.setItem('GlobalDateOnlyFormat', dates.convertDateFormat(tenant.GlobalDateOnlyFormat));
      else localStorage.removeItem('GlobalDateOnlyFormat');
      if (tenant.GlobalTimeOnlyFormat) localStorage.setItem('GlobalTimeOnlyFormat', dates.convertDateFormat(tenant.GlobalTimeOnlyFormat));
      else localStorage.removeItem('GlobalTimeOnlyFormat');

      if (tenant.EnhanceSubmissionProtection) localStorage.setItem('EnhanceSubmissionProtection', tenant.EnhanceSubmissionProtection);
      else localStorage.removeItem('EnhanceSubmissionProtection');

      const inactivityLogoutMinutes = parseInt(tenant.InactivityLogoutMinutes);
      if (!isNaN(inactivityLogoutMinutes)) {
        inactivityLogout.setInactivityLogoutMinutes(
          inactivityLogoutMinutes
        );
      }

      const inactivityLogoutMinutesGuest = parseInt(tenant.InactivityLogoutMinutesGuest);
      if (!isNaN(inactivityLogoutMinutesGuest)) {
        inactivityLogout.setInactivityLogoutMinutesGuest(
          inactivityLogoutMinutesGuest
        );
      }

      if (tenant.Modules)
        localStorage.setItem('modules', JSON.stringify(tenant.Modules));

      return tenant;
    }
    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
};

/**
 * 
 * @returns false if not allowed and null if failed to get
 */
async function allowGuestAccess() {
  //get tenant login settting to see if we can determine tenant from host
  try {
    const tenantId = sessionStorage.getItem('tenant') || localStorage.getItem('tenant') || undefined;
    const tenant = await getTenantFromHost(tenantId);
    if (!tenant || !tenant.ID) {
      //need a host header setting for the tenant
      return null;
    }

    if (tenant.AllowGuest != 'yes') {
      return false;
    }

    const authClient = await serviceClient.getClient("auth");
    const token = await authClient.apis.auth.getGuestToken({
      tenant: tenant.ID,
      setCookies: true,
    });
    return token;
  } catch (err) {
    console.error(err);
    console.error("Unable to locate tenant based on host name");
    return null;
  }
  //redirect to the destination
}

async function getSettings() {
  if (authSettings.isAuthenticated) {
    // debugger;
    return authSettings;
  }

  try {
    // debugger;
    // if (localStorage.getItem("integrifyToken")) {
    const result = await http.get(
      `${settings.microServiceRoot}/auth/jwt/isauthenticated`
    );
    authSettings = result.data;
    // } else {
    //   authSettings = {};
    // }
  } catch {
    authSettings = {};
  } finally {
    return authSettings;
  }
}

async function logout({ autoLogout = false, isGuest = false, guestLoginRequested = false } = {}) {
  log("previousActivity: ", localStorage.getItem("previousActivity"));
  user.setIsGuest(undefined);
  inactivityLogout.cleanStorage();
  sessionStorage.removeItem("currentUser");
  sessionStorage.removeItem("featureFlags");
  localStorage.removeItem("translatedLabels");

  document.cookie =
    "integrifyToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie =
    "integrifyRefreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  try {
    console.log("2446: commonLib.auth.logout TRACE:");
    console.trace();

    if (sessionStorage.getItem("useSingleLogout")) {
      sessionStorage.removeItem("useSingleLogout");
      // window.top because we could be in an ng iframe
      window.top.location.href = `${settings.microServiceRoot}/auth/sso/saml/logout`;
    } else {
      try {
        await http.delete(
          `${settings.microServiceRoot}/auth/dbauth/${sessionStorage.getItem(
            "tenant"
          )}`
        );

        if (autoLogout) await logToServer();

        authLog = "";
      } finally {
        redirect({ guestLogout: isGuest, guestLoginRequested });
      }
    }
  } catch (e) {
    console.log(e);
  }
  return;
}

function redirect({ guestLogout, guestLoginRequested }) {
  if (
    location.pathname != "/login" &&
    !location.pathname.startsWith("/workflow/actions/tasks/approvalbyemail/") &&
    !window.top.location.pathname.startsWith(
      "/workflow/actions/tasks/approvalbyemail/"
    )
  ) {
    if (guestLogout) {
      window.top.location.href = `${location.origin}/login/guest-timeout`;
    } else {
      const redirect = encodeURIComponent(
        location.pathname + location.search + location.hash
      );

      // window.top because we could be in an ng iframe
      window.top.location.href = `${location.origin}/login?${guestLoginRequested ? 'guest=true&' : ''}redirect=${redirect}`;
    }
  }
}

async function createSession() {
  let tenantId = sessionStorage.getItem('tenant') || localStorage.getItem('tenant') || undefined;
  if (!tenantId) {
    const tenant = await getTenantFromHost(tenantId);
    tenantId = tenant?.ID;
  }

  try {
    await http.post(
      `${settings.microServiceRoot}/auth/session/create?tenant=${encodeURIComponent(tenantId)}`, { deviceGuid: getDeviceGuid() }, 
    );
  } catch (e) {
    console.error('Error creating session', e);
  }
}

async function logToServer() {
  try {
    const user = require("../user").default;
    if (user && user.currentUser && user.currentUser.SID)
      log("user: ", user.currentUser.SID);

    if (window.portalEventBus) log("from vue");
    if (window.angular) log("from angular");

    await http.post(`${settings.microServiceRoot}/auth/log`, {
      message: authLog,
    });
  } catch {
    console.log("Unable to log to server");
  }
}

function log() {
  var message = Array.prototype.join.call(arguments, " ");
  authLog += message + "\n";
  console.log(message);
}

const auth = {
  getSettings,
  logout,
  getTenantFromHost,
  allowGuestAccess,
  log,
  createSession,
};

export default auth;
